import { lazy } from 'react';

const Table = lazy(() => import('./Table'));

export { Table };
